import { render, staticRenderFns } from "./editSupplier.vue?vue&type=template&id=c473b252&scoped=true&"
import script from "./editSupplier.vue?vue&type=script&lang=js&"
export * from "./editSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c473b252",
  null
  
)

export default component.exports